export default {
  FETCH_SOURCES: "FETCH_SOURCES",
  FETCH_SESSIONS: "FETCH_SESSIONS",
  FETCH_SETS: "FETCH_SETS",

  SIGN_OUT: "SIGN_OUT"
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js